export default __webpack_public_path__ + "8a666a3cb62543c7208225f83ece4937.png";